import React from "react";

import { QRadio, QRadioGroup, QStack } from "@qualio/ui-components";

type RadioGroupProps = {
  defaultValue?: any;
  onChange: (value: any) => void;
  options: Array<{ label: string; value: any }>;
  direction?: "row" | "column";
};

export const RadioGroup: React.FC<RadioGroupProps> = ({
  defaultValue,
  onChange,
  options,
  direction = "column",
  ...htmlProps
}) => {
  return (
    <QRadioGroup onChange={onChange} value={defaultValue}>
      <QStack direction={direction}>
        {options.map(({ label, value }) => (
          <QRadio key={value} value={value} {...htmlProps}>
            {label}
          </QRadio>
        ))}
      </QStack>
    </QRadioGroup>
  );
};
